// The new design's frame: a left menu (a dropdown on phones) and the page beside it.
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSite } from "@/lib/site";
import { isAccountant, roleLabel } from "@/lib/roles";

export const V2_NAV = [
  { to: "/v2", label: "Dashboard", exact: true },
  { to: "/v2/shifts", label: "Shifts", match: ["/v2/shifts", "/v2/shift/"] },
  { to: "/v2/deliveries", label: "Deliveries" },
  { to: "/v2/stock", label: "Stock" },
  { to: "/v2/banking", label: "Banking" },
  { to: "/v2/customers", label: "Customers", accountant: true },
  { to: "/v2/reports", label: "Reports" },
  { to: "/v2/settings", label: "Settings" },
];

export default function Layout2({ children }) {
  const site = useSite();
  const { user, logout } = useAuth();
  const loc = useLocation();
  const navigate = useNavigate();
  const items = V2_NAV.filter((n) => !n.accountant || isAccountant(user));
  const active = (n) => (n.exact ? loc.pathname === n.to : (n.match || [n.to]).some((m) => loc.pathname.startsWith(m)));
  return (
    <div className="flex min-h-screen flex-col bg-white text-slate-800 md:flex-row">
      <nav aria-label="Main" className="border-b border-slate-200 bg-slate-50 md:sticky md:top-0 md:h-screen md:w-[232px] md:flex-none md:border-b-0 md:border-r">
        <div className="flex h-full flex-col px-3 py-4 md:py-5">
          <div className="px-3 pb-3 md:pb-5">
            <div className="text-base font-bold text-slate-900">{site.short_name || "Station"}</div>
            <div className="text-xs text-slate-500">{site.operator}</div>
          </div>
          <select aria-label="Go to" className="mx-1 mb-1 min-h-[40px] rounded-md border border-slate-300 bg-white px-2 text-sm md:hidden"
            value={items.find(active)?.to || "/v2"} onChange={(e) => navigate(e.target.value)}>
            {items.map((n) => <option key={n.to} value={n.to}>{n.label}</option>)}
          </select>
          <div className="hidden flex-col gap-0.5 md:flex">
            {items.map((n) => (
              <Link key={n.to} to={n.to} aria-current={active(n) ? "page" : undefined}
                className={`rounded-md px-3 py-2.5 text-sm ${active(n) ? "bg-brand/10 font-semibold text-slate-900" : "text-slate-600 hover:bg-slate-100"}`}>
                {n.label}
              </Link>
            ))}
          </div>
          <div className="mt-auto hidden px-3 pt-6 text-xs text-slate-500 md:block">
            <div className="font-medium text-slate-700">{user?.name || user?.email}</div>
            <div>{roleLabel(user?.role)}</div>
            <div className="mt-3 flex flex-col gap-1.5">
              <Link to="/" className="text-sky-700 hover:underline">Back to the current design</Link>
              <button type="button" className="w-fit text-left text-sky-700 hover:underline" onClick={async () => { await logout(); navigate("/login"); }}>Sign out</button>
            </div>
          </div>
        </div>
      </nav>
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
